import { createTheme } from '@mui/material/styles';
import tokens, {
  colors,
  semanticColors,
  typography,
  breakpoints,
  radius,
  shadows,
  zIndex,
} from '../assets/design-tokens';

const baseTypography = {
  fontFamily: typography.fontFamily.primary,
  h1: { fontSize: typography.fontSize[48], fontWeight: typography.fontWeight.bold, lineHeight: typography.lineHeight.heading },
  h2: { fontSize: typography.fontSize[40], fontWeight: typography.fontWeight.bold, lineHeight: typography.lineHeight.heading },
  h3: { fontSize: typography.fontSize[28], fontWeight: typography.fontWeight.semiBold, lineHeight: typography.lineHeight.heading },
  h4: { fontSize: typography.fontSize[24], fontWeight: typography.fontWeight.semiBold },
  h5: { fontSize: typography.fontSize[20], fontWeight: typography.fontWeight.medium },
  h6: { fontSize: typography.fontSize[18], fontWeight: typography.fontWeight.medium },
  subtitle1: { fontSize: typography.fontSize[16] },
  subtitle2: { fontSize: typography.fontSize[14] },
  body1: { fontSize: typography.fontSize[16] },
  body2: { fontSize: typography.fontSize[14] },
  button: { textTransform: 'none', fontWeight: typography.fontWeight.medium },
  caption: { fontSize: typography.fontSize[12] },
};

const baseBreakpoints = {
  values: {
    xs: 0,
    sm: breakpoints.sm,
    md: breakpoints.md,
    lg: breakpoints.lg,
    xl: breakpoints.xl,
  },
};

const baseZIndex = { ...zIndex };

const baseComponents = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: radius.md,
        fontWeight: typography.fontWeight.medium,
        textTransform: 'none',
      },
    },
  },
};

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: colors.brand,
      light: colors.primary[300],
      dark: colors.primary[700],
      contrastText: semanticColors.onPrimary,
    },
    secondary: {
      main: colors.white,
      contrastText: colors.black[1],
    },
    error: { main: colors.error[500] },
    warning: { main: colors.warning[300] },
    info: { main: colors.information[400] },
    success: { main: colors.success[400] },
    background: {
      default: semanticColors.background,
      paper: colors.gray[3],
      footer: colors.brand,
    },
    text: {
      primary: colors.black[1],
      secondary: colors.brand,
      disabled: semanticColors.disabled,
    },
    divider: semanticColors.divider,
  },
  typography: baseTypography,
  breakpoints: baseBreakpoints,
  zIndex: baseZIndex,
  spacing: 8,
  shape: { borderRadius: 4 },
  components: baseComponents,
  tokens,
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: colors.brand,
      contrastText: colors.white,
    },
    secondary: {
      main: '#f3f3f3',
      contrastText: colors.black[1],
    },
    error: { main: colors.error[500] },
    warning: { main: colors.warning[300] },
    info: { main: colors.information[400] },
    success: { main: colors.success[400] },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
      footer: colors.brand,
    },
    text: {
      primary: '#f3f3f3',
      secondary: '#cfcfcf',
    },
  },
  typography: baseTypography,
  breakpoints: baseBreakpoints,
  zIndex: baseZIndex,
  spacing: 8,
  shape: { borderRadius: 4 },
  components: {
    ...baseComponents,
    MuiInputLabel: { styleOverrides: { root: { color: '#cfcfcf' } } },
    MuiInput: { styleOverrides: { input: { color: '#f3f3f3' } } },
    MuiPaper: { styleOverrides: { root: { backgroundColor: '#1e1e1e' } } },
    MuiAppBar: { styleOverrides: { root: { backgroundColor: colors.brand, color: colors.white } } },
  },
  tokens,
});

export { shadows };

const appThemes = { lightTheme, darkTheme };
export default appThemes;
